import Icon from '@mui/icons-material/HelpOutline';
import { IconButton, Tooltip } from '@mui/material';

export default function HelpMenu(props) {

    const handleClick = () => { }

    return (
        <Tooltip title="Pomoc">
            <IconButton
                id='header-help-button'
                onClick={handleClick} >
                <Icon sx={{ width: 28, height: 28, color:'white' }} />
            </IconButton>
        </Tooltip>
    );
}